module.exports = __webpack_public_path__ + "a9534ebb7f4d252ff9a9599a13115b5e.svg";